import styled from 'styled-components';

const CompanyRulesStyled = styled.div`
  .company-wrap {
    align-items: center;
  }
  .basic-cycle {
    margin-top: ${(props) => props.theme.spacing(41 / 8)};
  }
  .cycle-select-wrap {
    display: flex;
    flex-direction: row;
  }
  .company-select-wrap {
    display: flex;
    flex-direction: row;
  }
  .multiple-select {
    line-height: 1;
    margin-top: -15px;
  }
`;

export default CompanyRulesStyled;
